import type {
  ModelAssignFormValues,
  ModelAssignFormProps,
} from "./model-assign-form.type";

import { Form } from "antd";
import { useEffect } from "react";

import { useFormValidation } from "@/modules/form-validation";
import { useSidePanel } from "@/modules/side-panel";
import { getUsersSelectOptionItems } from "@/modules/users/users-select";

export const useModelAssignForm = ({
  existingUsers,
  onSubmit,
  status,
  error,
}: ModelAssignFormProps) => {
  const { closeSidePanel } = useSidePanel();

  const [form] = Form.useForm<ModelAssignFormValues>();

  const initialValues: ModelAssignFormValues = {
    users: getUsersSelectOptionItems(existingUsers),
  };

  const { validationErrors, validation } = useFormValidation(
    status === "error",
    error,
    ["users"]
  );

  useEffect(() => {
    if (status === "success") closeSidePanel();
  }, [status, closeSidePanel]);

  return {
    form,
    initialValues,
    loading: status === "pending",
    onSubmit,
    validation,
    validationErrors,
  };
};
